const generateNavBar = (data) => {
  const { country = 'ID' } = data;

  const baseMenu = [
    {
      label: 'Stream',
      href: '/stream',
      logoWeb: 'icon-menu_home',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/stream')) {
          return true;
        }

        return false;
      },
      logoMobile: 'icon-menu3_home',
      'data-cy': 'navbar-stream',
    },
    {
      label: 'Profile',
      logoWeb: 'icon-menu_profile',
      href: `/${data.username}`,
      matcher: (router) => {
        const { asPath } = router;

        if (data.username && asPath.includes(`/${data.username}`)) {
          return true;
        }

        return false;
      },
      logoMobile: 'icon-menu3_profile',
      'data-cy': 'navbar-profile',
    },
    {
      label: 'Watchlist',
      href: '/watchlist',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/watchlist')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_watchlist',
      logoMobile: 'icon-menu3_watchlist',
      'data-cy': 'navbar-watchlist',
    },
    {
      label: 'Portfolio',
      href: '/securities/portfolio',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/securities/portfolio')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_portfolio',
      logoMobile: 'icon-menu3_portfolio',
      'data-cy': 'navbar-portfolio',
    },
    {
      label: 'Orderbook',
      href: '/orderbook',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/orderbook')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_orderbook',
      logoMobile: 'icon-menu3_orderbook',
      'data-cy': 'navbar-orderbook',
    },
  ];

  const mockMenu = [
    {
      label: 'Chartbit',
      href: '/symbol/IHSG/chartbit',
      matcher: (router) => {
        const { pathname } = router;

        if (pathname.includes('/symbol/[SYMBOL]/chartbit')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_chartbit',
      logoMobile: 'icon-menu3_chartbit',
      'data-cy': 'navbar-chartbit',
    },
    {
      label: 'e-IPO',
      href: '/e-ipo',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/e-ipo')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu3_eipo',
      logoMobile: 'icon-menu3_eipo',
      'data-cy': 'navbar-ipo',
    },
    {
      label: 'Screener',
      href: '/screener',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/screener')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_screener',
      logoMobile: 'icon-menu3_screener',
      'data-cy': 'navbar-screener',
    },
    {
      label: 'Academy',
      href: '/academy?refresh=1',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/unboxing')) {
          return true;
        }

        if (asPath.includes('/academy')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_academy',
      logoMobile: 'icon-menu3_academy',
      'data-cy': 'navbar-academy',
    },
    {
      label: 'Insider Activity',
      href: '/insider',
      matcher: (router) => {
        const { asPath } = router;
        return asPath === '/insider/';
      },
      logoWeb: 'icon-insider',
      logoMobile: 'icon-insider',
      'data-cy': 'navbar-insider',
    },
    {
      label: 'Valuation',
      href: '/valuation',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/valuation')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_valuation',
      logoMobile: 'icon-menu3_valuation',
      'data-cy': 'navbar-valuation',
    },
    {
      label: 'Financials',
      href: '/symbol/AALI/financials',
      matcher: (router) => {
        const { pathname } = router;

        if (pathname.includes('/symbol/[SYMBOL]/financials')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_financials',
      logoMobile: 'icon-menu3_financials',
      'data-cy': 'navbar-financials',
    },
    {
      label: 'Fundachart',
      href: '/symbol/AALI/fundachart',
      matcher: (router) => {
        const { pathname } = router;

        if (pathname.includes('/symbol/[SYMBOL]/fundachart')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_fundachart',
      logoMobile: 'icon-menu3_fundachart',
      'data-cy': 'navbar-fundachart',
    },
    {
      label: 'Seasonality',
      href: '/symbol/AALI/seasonality',
      matcher: (router) => {
        const { pathname } = router;

        if (pathname.includes('/symbol/[SYMBOL]/seasonality')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_seasonality',
      logoMobile: 'icon-menu3_seasonality',
      'data-cy': 'navbar-seasonality',
    },
    {
      label: 'Sector',
      href: '/sector',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/sector')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_sector',
      logoMobile: 'icon-menu3_sector',
      'data-cy': 'navbar-sector',
    },
    {
      label: 'Calendar',
      href: '/calendar',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/calendar')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_calendar',
      logoMobile: 'icon-menu3_calendar',
      'data-cy': 'navbar-calendar',
    },
    {
      label: 'Earnings',
      href: '/earnings',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/earnings')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_earning',
      logoMobile: 'icon-menu3_earning',
      'data-cy': 'navbar-earning',
    },
    {
      label: 'Glossary',
      href: '/glossary',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/glossary')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_glossary',
      logoMobile: 'icon-menu3_glossary',
      'data-cy': 'navbar-glossary',
    },
    {
      label: 'Ebook',
      href: '/ebook',
      matcher: (router) => {
        const { asPath } = router;

        if (asPath.includes('/ebook')) {
          return true;
        }

        return false;
      },
      logoWeb: 'icon-menu_ebook',
      logoMobile: 'icon-menu3_ebook',
      'data-cy': 'navbar-ebook',
    },
  ];

  if (country === 'MY') {
    return baseMenu;
  }

  return [...baseMenu, ...mockMenu];
};

export default generateNavBar;
